import type { Path } from '@exam-management/router';

export function checkPathMatchings(locationPathname: string, path?: Path) {
  const locationSplitted = locationPathname.split('/');
  const pathSplitted = path?.split('/') ?? [];

  return (
    pathSplitted.length === locationSplitted.length &&
    pathSplitted.every((path, index) => {
      return path === locationSplitted[index] || path.includes(':');
    })
  );
}

export function removeHtmlTag(
  content: string,
  options?: {
    customTag?: string;
  },
) {
  const { customTag } = options ?? {};
  const htmlTag = customTag ? `<${customTag}[^>]*>|</${customTag}>` : '<[^>]*>|</[^>]*>';
  return content.replace(new RegExp(htmlTag, 'g'), '');
}
